import React from "react";
export default function HeaderElement() {
  return (
    <div>
      <header>
        <div className="primary-bar bg-light">
          <div className="mobile-bar">
            <div className="mobile-logo"></div>
            <div className="button-space">
              <div className="top-buttons ">
                <a href="../search" className="button button-1 no-underline">
                  <i className="fa-solid fa-magnifying-glass fa-lg"></i>Search
                </a>
              </div>
              <div className="top-buttons ">
                <a href="../citizenreporter" className="button button-1 no-underline">
                  <i className="fa-solid fa-screwdriver-wrench fa-lg"></i>Citizen Reporter
                </a>
              </div>
            </div>
          </div>

          <div className="primary-bar-left">
            <div className="logo-space"></div>
            <div className="text-space"></div>
          </div>
          <div className="primary-bar-right">
            <div className="mb-info-space">
              <div className="mb-nav-info">
                <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                  <div className="mb-nav-info-icon">
                    <img src="../img/svg-icons/map-pin.svg" alt="Map with Pin icon" className="padding-right-point25em" />
                  </div>
                  <div className="mb-nav-info-text">
                    <p>
                      &nbsp;35 Union Street
                      <br />&nbsp;Morrisville, PA 19067
                    </p>
                  </div>
                </a>
              </div>
              <div className="mb-contact-info">
                <a href="/contact">
                  <div className="mb-contact-info-icon">
                    <img src="../img/svg-icons/contact.svg" alt="phone icon" className="padding-right-point25em" />
                  </div>
                  <div className="mb-contact-info-text">
                    Contact
                    <br />
                    &nbsp;
                  </div>
                </a>
              </div>
            </div>
            <div className="button-space">
              <div className="top-buttons">
                <a href="../search" className="button button-1 no-underline">
                  <i className="fa-solid fa-magnifying-glass fa-lg af-icon"></i>&nbsp;Search
                </a>
              </div>
              <div className="top-buttons ">
                <a href="../citizenreporter" className="button button-1 no-underline">
                  <i className="fa-solid fa-screwdriver-wrench fa-lg af-icon"></i>&nbsp;Citizen Reporter
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <nav>
        <div className="navbar navbar-expand-md fixed-top">
          <div className="container-lg">
            <button className="navbar-toggler text-center" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
              <i className="fa-solid fa-bars fa-lg"></i>&nbsp;Menu
            </button>
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
              <div className="offcanvas-header">
                <div className="offcanvas-title" id="offcanvasNavbarLabel">
                  <h3>Morrisville Borough, PA</h3>
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8" className="no-underline">
                    <i className="fa-solid fa-location-pin mobile-icons-color"></i>&nbsp;35 Union Street&nbsp;Morrisville, PA 19067
                  </a>
                  <br />
                  <a href="tel:2152958181" className="no-underline">
                    <i className="fa-solid fa-phone mobile-icons-color"></i>&nbsp;215-295-8181
                  </a>
                  <br />
                  <a href="mailto:info@morrisvilleboro.org" className="no-underline">
                    <i className="fa-solid fa-envelope mobile-icons-color"></i>&nbsp;info@morrisvilleboro.org
                    <br />
                  </a>
                </div>
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>
              <div className="offcanvas-body">
                <hr className="mobile-only-hr" />
                <ul className="navbar-nav justify-content-center flex-grow-1 pe-3">
                  <li className="mobile-only">
                    <dl>
                      <dt>Site Navigation</dt>
                    </dl>
                  </li>
                  <li className="nav-item">
                    <a href="/" className="nav-link active mobile-right-arrow" aria-current="page">
                      Home
                    </a>
                  </li>
                  <li className="nav-item dropdown">
                    <button
                      type="button"
                      id="button-govnav"
                      className="nav-link dropdown-toggle caret-off mobile-right-arrow AutoClose"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      Government
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <a href="/administration" className="dropdown-item">
                          Administration
                        </a>
                      </li>
                      <li className="dropdown-submenu dropend">
                      <button
                      type="button"
                      id="button-boardsnav"
                      className="dropdown-item dropdown-toggle"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      Boards &amp; Commissions
                    </button>
                        <ul className="dropdown-menu">
                        <li>
                            <a className="dropdown-item" href="/civilservice">
                              Civil Service Commission
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/eac">
                              Environmental Advisory Council
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/jsbbc">
                              Joint School Board &amp; Council
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/libraryboard">
                              Library Board
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/medc">
                              Economic Development Corp (MEDC)
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/mma">
                              Municipal Authority (Water &amp; Sewer)
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/planning">
                              Planning Commission
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/vprb">
                              Vacant Property Review Board
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="/zoning">
                              Zoning Hearing Board
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/council" className="dropdown-item">
                          Borough Council
                        </a>
                      </li>
                      <li>
                        <a href="/mayor" className="dropdown-item">
                          Mayor's Office
                        </a>
                      </li>
                      <li>
                        <a href="/tax" className="dropdown-item">
                          Tax Collector
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                  <button
                      type="button"
                      id="button-resourcesnav"
                      className="nav-link dropdown-toggle caret-off mobile-right-arrow AutoClose"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      Resources
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <a className="dropdown-item" href="/code">
                          Code Enforcement
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="https://www.morrisville98.com/">
                          Fire Company &nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="https://www.morrisvillepalibrary.org/ ">
                          Library &nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/police">
                          Police
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/publicworks">
                          Public Works
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="https://www.capitalhealth.org/medical-services/emergency-medical-services">
                          Rescue Squad&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="https://www.mv.org/">
                          School District &nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/stormwater">
                          Stormwater Management
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="https://www.morrisvilleseniorservicenter.org/">
                          Senior Center &nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/sanitation">
                          Sanitation
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/water-sewer">
                          Water &amp; Sewer
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                  <button
                      type="button"
                      id="button-infonav"
                      className="nav-link dropdown-toggle caret-off mobile-right-arrow AutoClose"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      Information
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <a className="dropdown-item" href="../docs/info/2026-Fee-Schedule.pdf">
                          2026 Fee Schedule &nbsp;<i className="fa-solid fa-file-pdf"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="../docs/budgets/2026-FINAL-BUDGET-WITH-SUMMARY-SHEET.pdf">
                          2026 Budget &nbsp;<i className="fa-solid fa-file-pdf"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="https://ecode360.com/MO2399">
                          2026 Borough Code &nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/calendar">
                          Borough Calendar
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/contact">
                          Contact Information
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/docs">
                          Document Archive
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/employment">
                          Employment Opportunities
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/howdoi">
                          How Do I?...
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/resources">
                          Local Area Resources
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/rtk">
                          Right-To-Know Requests
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link caret-off mobile-right-arrow" href="/forms">
                      Forms
                    </a>
                  </li>

                  <li className="mobile-only">
                    <br />
                    <dl>
                      <dt>Quick Links</dt>
                    </dl>
                    <div className="icon-bar" aria-label="secondary navigation">
                      <a href="/police" className="button no-underline  ">
                        <div className="icon-button-police-icon">
                          <img src="../img/svg-icons/police.svg" alt="police icon" />
                        </div>
                        <div className="icon-button-text">Police</div>
                      </a>
                      <a href="/sanitation" className="button no-underline ">
                        <div className="icon-button-trash-icon">
                          <img src="../img/svg-icons/trash.svg" alt="trash can icon" />
                        </div>
                        <div className="icon-button-text">Sanitation</div>
                      </a>
                      <a href="/calendar" className="button no-underline ">
                        <div className="icon-button-calendar-icon">
                          <img src="../img/svg-icons/calendar.svg" alt="calendar icon" />
                        </div>
                        <div className="icon-button-text">Calendar</div>
                      </a>
                      <a href="/tourism" className="button no-underline ">
                        <div className="icon-button-tourism-icon">
                          <img src="../img/svg-icons/tourism.svg" alt="tourism icon" />
                        </div>
                        <div className="icon-button-text">Tourism</div>
                      </a>

                      <a href="/howdoi" className="button no-underline ">
                        <div className="icon-button-howdoi-icon">
                          <img src="../img/svg-icons/howdoi.svg" alt="how do I icon" />
                        </div>
                        <div className="icon-button-text">How Do I?...</div>
                      </a>
                      <a href="/docs" className="button ">
                        <div className="icon-button-documents-icon">
                          <img src="../img/svg-icons/folder-open1.svg" alt="open folder icon" />
                        </div>
                        <div className="icon-button-text">Documents</div>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
